import React from "react";
import { useI18n } from "@/context/I18nContext";

export default function LegalPage({ pageKey }) {
  const { t, dict } = useI18n();
  const page = dict?.pages?.[pageKey];
  if (!page) return null;

  const sections = Object.keys(page.sections || {});

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-10">
        <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700">
          {t("brand.name")}
        </p>
        <h1
          data-testid={`${pageKey}-page-title`}
          className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl"
        >
          {page.title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{page.updated}</p>
        <p className="mt-8 text-base leading-relaxed text-slate-700">
          {page.intro}
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((key) => (
            <div key={key} data-testid={`${pageKey}-section-${key}`}>
              <h2 className="font-heading text-xl font-semibold text-slate-900 sm:text-2xl">
                {page.sections[key].title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate-700">
                {page.sections[key].body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
